module.exports = __webpack_public_path__ + "img/blur-chart-check-up-curve-415779.9024a48e.webp";